// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"9e53e392","558":"29b6d3fb","830":"b0ce22bb","883":"b461a7ee","930":"6720e5e1"}[chunkId] + ".chunk.js";
};